import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en.json";
import hiTranslation from "./locales/hi.json";
import frTranslation from "./locales/fr.json";
import esTranslation from "./locales/es.json";
import ptTranslation from "./locales/pt.json";

const resources = {
  en: { translation: enTranslation },
  hi: { translation: hiTranslation },
  fr: { translation: frTranslation },
  es: { translation: esTranslation },
  pt: { translation: ptTranslation }
};

// User ka pichla selected language yaad rakho, pehli baar English default
const savedLanguage = localStorage.getItem("chirayuLang") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

// Jab bhi language change ho, localStorage mein save karo
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("chirayuLang", lng);
});

export default i18n;
